import * as Types from '../action-types';
import update from 'immutability-helper';

const initialState = {
    pager: {
        totalPages: 0,
        pageNumber: 0,
        visiblePages: 5,
        titles: { first: 'First', last: 'Last' },
        pageSize: 5
    },
    results: []
};

let hotelSearchReducer = function(state = initialState, action) {
    switch (action.type) {
        case Types.SELECT_ALL_HOTELS:
            return update(state, {
                results: {
                    $apply: (hotels) => {
                        return hotels.map((hotel) => {
                            return update(hotel, {
                                selected: { $set: action.response.selectAll }
                            });
                        });
                    }
                }
            });
        case Types.CHANGE_HOTEL_SELECTION:
            return update(state, {
                results: {
                    [action.response.index]: {
                        selected: { $set: action.response.hotel.selected ? false : true }
                    }
                }
            });
        case Types.SEARCH_SUCCESS:
            return update(state, {
                results: { $set: action.response.hotels },
                pager: {
                    totalPages: { $set: 1 }, // Math.ceil(action.response.totalItemCount / state.pager.pageSize)
                    pageNumber: { $set: 1 } // (action.response.pageNumber - 1)
                }
            });
        default:
            return state;
    }
};

export default hotelSearchReducer;
